import stagingHighlights from 'config/stagingHighlights.json';
import menuBadges from 'config/newMenuBadges.json';

// Missing types preserve the original New-badge behavior.
export const featureType = item => item.type === 'updated' ? 'updated' : 'new';
export const preferredFeatureType = types => types.includes('new') ? 'new' : types.includes('updated') ? 'updated' : null;

export const getMenuFeatureType = (path, environment, now) => {
    const types = [];
    if (environment === 'staging') {
        types.push(...stagingHighlights.filter(item => item.path === path).map(featureType));
    }
    if (['staging', 'production'].includes(environment)) {
        types.push(...menuBadges.filter(item => item.path === path && Date.parse(item.expiresAt) > now).map(featureType));
    }
    return preferredFeatureType(types);
};
